/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_Q2_CInputs */

const en_consult_q2_c = /** @type {(inputs: Consult_Q2_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Over $3,000`)
};

const id_consult_q2_c = /** @type {(inputs: Consult_Q2_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di atas Rp30 juta`)
};

/**
* | output |
* | --- |
* | "Over $3,000" |
*
* @param {Consult_Q2_CInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_q2_c = /** @type {((inputs?: Consult_Q2_CInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Q2_CInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_q2_c(inputs)
	return en_consult_q2_c(inputs)
});